import { useCallback, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { FilledButton } from 'components';
import useSettingsModalStyles from '../SettingsModal/SettingsModal.styles';
import { deleteModeContext } from '../../ShareExplorer/FolderContentExplorer/DeleteMode/DeleteModeContext';
import { settingsContext } from '../SettingsModal/SettingsContext';
import useSmallDesktopScreen from 'hooks/useSmallDesktopScreen';
import MobileExplorerToolbarMenuItemButton from 'mobile/App/Share/ExplorerToolbar/MobileExplorerToolbarMenuItemButton';

export type DeleteDocumentButtonPureProps = {
  handleDeleteFiles: () => void;
};

export const DeleteDocumentButtonPure = ({
  handleDeleteFiles,
}: DeleteDocumentButtonPureProps): JSX.Element => {
  const settingsModalClasses = useSettingsModalStyles();

  return (
    <FilledButton
      className={settingsModalClasses.button}
      color="violet"
      data-testid="delete-document-button"
      onClick={handleDeleteFiles}
    >
      <FormattedMessage id="share.folder.settings.deleteFile" />
    </FilledButton>
  );
};

export const DeleteDocumentButton = (): JSX.Element => {
  const { setIsDeleteMode } = useContext(deleteModeContext);
  const { setShowSettingsModal } = useContext(settingsContext);
  const isSmallScreen = useSmallDesktopScreen();

  const handleDeleteFiles = useCallback(() => {
    setShowSettingsModal(false);
    setIsDeleteMode(true);
  }, [setIsDeleteMode, setShowSettingsModal]);

  if (isSmallScreen) {
    return (
      <MobileExplorerToolbarMenuItemButton
        messageId="share.folder.settings.deleteFile"
        onClick={handleDeleteFiles}
      />
    );
  }

  return <DeleteDocumentButtonPure handleDeleteFiles={handleDeleteFiles} />;
};

export default DeleteDocumentButton;
